import ApiService from './ApiService'
import appConfig from '../configs/app.config'

export async function apiSignIn (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'weblogin',
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'client_type': 'web'
        },
        data
    })
}

export async function apiCheckAuth (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'webrefreshtoken',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

export async function apiSignUp (data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data
    })
}

export async function apiSignOut (data) {
	localStorage.removeItem('project_id');
	localStorage.removeItem('project_name');
    /*
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })
    */
}

/**
 * Forgot Password API
 * @endpoint POST /forgetpassword
 * @headers: NONE (no authentication required)
 * @request {
 *   e_mail: string,              // NOT "email" - API uses "e_mail"
 *   reset_type?: "sms" | "e_mail"  // Optional: if not sent, returns available methods
 * }
 * @response {
 *   Status: "Normal" | "Error",
 *   Content: "Verification code sent to user" | { available_methods: ["sms", "e_mail"] }
 * }
 */
export async function apiForgotPassword (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'forgetpassword',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

/**
 * Change Password API (authenticated)
 * @endpoint POST /changepassword
 * @headers { token: string }
 * @request {
 *   current_password: string,
 *   new_password: string
 * }
 * @response {
 *   Status: "Normal" | "Error",
 *   Content: string
 * }
 */
export async function apiChangePassword (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'changepassword',
        method: 'post',
        data
    })
}

/**
 * Confirm Password API (verify code and change password)
 * @endpoint POST /confirmpassword
 * @headers: NONE (no authentication required)
 * @request {
 *   e_mail: string,              // NOT "email" - API uses "e_mail"
 *   confirmation_code: string,
 *   new_password: string,
 *   reset_type: "sms" | "e_mail" // REQUIRED - must match the method used in forgetpassword
 * }
 * @response {
 *   Status: "Normal" | "Error",
 *   Content: "User password changed and new password saved"
 * }
 */
export async function apiVerifyCodeAndChangePassword (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'confirmpassword',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}


export async function apiResetPassword (data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data
    })
}

/**
 * Mobile Login API
 * @endpoint POST /moblogin
 * @headers {
 *   project_id: string,
 *   serial: string,
 *   client_type: "mob"
 * }
 * @request {
 *   email: string,      // Kullanıcı emaili (örn: "test.kullanici1")
 *   password: string,   // Şifre (örn: "123")
 *   version: string,    // Versiyon (örn: "v2")
 *   os: string          // İşletim sistemi (örn: "Android", "iOS", "Postman")
 * }
 * @response {
 *   Status: "Normal" | "Error",
 *   Content: {
 *     token: string,
 *     user_id: number,
 *     ...
 *   }
 * }
 */
export async function apiMobileSignIn(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'moblogin',
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'client_type': 'mob'
        },
        data
    })
}

/**
 * Password Regex API - Şifre kurallarını döndürür
 * @endpoint GET /passwordregex
 * @response {
 *   Status: "Normal" | "Error",
 *   Content: {
 *     pattern: string,      // Regex pattern (örn: "^(?=.*[A-Z])(?=.*[0-9]).{8,}$")
 *     description: string   // Kullanıcıya gösterilecek açıklama
 *   }
 * }
 */
export async function apiGetPasswordRegex() {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'passwordregex',
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
